import { render, staticRenderFns } from "./CorrectContainerInfo.vue?vue&type=template&id=0c550653"
import script from "./CorrectContainerInfo.vue?vue&type=script&lang=js"
export * from "./CorrectContainerInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports